<template>
  <div id="vehicleInfo">
    <MyLine/>
    <div id="box">
      <div id="title">车辆信息</div>
      <div id="content">
        <div class="row">
          <p>车牌号</p>
          <p>{{carNum}}</p>
        </div>
        <div class="row">
          <p>车辆识别号</p>
          <p>{{VIN}}</p>
        </div>
        <div class="row">
          <p>发动机号码</p>
          <p>{{engineNum}}</p>
        </div>
        <div class="row">
          <p>注册日期</p>
          <p>{{recordDate | formatDate}}</p>
        </div>
        <div class="row">
          <p>是否运营</p>
          <p>{{operate===1 ? '运营' : (operate===0 ? '非运营' : '运营状态未知')}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import MyLine from '../widget/line'

  export default {
    name: "vehicleInfo",
    props:{
      carNum:{type: String, default: '------'},
      VIN:{type: String, default: '--------'},
      engineNum:{type: String, default: '------'},
      recordDate:{type: Number,},
      operate:{type: Number,},
    },
    components:{
      MyLine,
    },
    filters:{
      formatDate(dateTime) {
        if ((''+dateTime).length === 10) {
          return new Date(dateTime*1000).Format('yyyy/MM/dd')
        }
        return '----/--/--';
      }
    },
  }
</script>

<style scoped>
  #box{
    width: 92vw;
    margin: 0 auto;
    background: white;
    border-radius: 1.333vw;
    box-sizing: border-box;
    padding: 2.667vw 3.2vw;
  }
  #title{
    font-size: 3.2vw;
    color: #909399;
    padding-bottom: 2vw;
    border-bottom: 1px solid #edeff2;
  }
  #content{
    margin-top: 4vw;
  }
  .row{
    min-height: 6vw;
    display: flex;
  }
  .row>p:first-child{
    width: 20vw;
    font-size: 3.467vw;
    color: #909399;
  }
  .row>p:last-child{
    flex: 1;
    font-size: 3.467vw;
    color: #303133;
  }
</style>
